import { styled } from '@linaria/react';

export const DefaultBetsGridWrapper = styled.div``;

export const TableHeaderWrapper = styled.div`
  background: var(--oc-bg-grey);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 15px;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const TableHeaderText = styled.div`
  font-family: var(--oc-font-family);
  color: var(--oc-text-subtext);
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;

export const DefaultBetsGridContainer = styled.div<{ numberOfRows: number }>`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  padding: 0;

  @media (min-width: 1024px) {
    grid-template-rows: repeat(${(props: { numberOfRows: number }) => props.numberOfRows}, auto);
  }
`;

export const BetItem = styled.div<{ itemIndex: number }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  user-select: none;
  border-bottom: 1px solid var(--oc-line-secondary);

  @media (min-width: 768px) {
    justify-content: space-between;
    padding: 12px 15px;
    border-right: 1px solid var(--oc-line-secondary);
    border-bottom: none;
  }

  @media (min-width: 600px) {
    &:last-of-type {
      border-right: ${({ itemIndex }: { itemIndex: number }) =>
        itemIndex === 2 ? 'none' : '1px solid var(--oc-line-secondary)'};
    }
  }
`;

export const BetItemRow = styled.div`
  @media (min-width: 768px) {
    padding: 0;
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    border-bottom: 1px solid var(--oc-line-secondary);
  }
`;

export const BetName = styled.a`
  color: var(--oc-text-body);
  font-family: var(--oc-font-family);
  font-weight: 400;
  font-size: 16px;
  font-style: normal;
  line-height: 19px;
  text-decoration: none;
  word-wrap: break-word;
  padding-right: 10px;

  &:hover {
    text-decoration: underline;
  }

  &.disabled {
    cursor: none;
    pointer-events: none;
    opacity: 0.5;

    &:hover {
      text-decoration: none;
    }
  }
`;

export const OddButtonContainer = styled.div``;

export const BetsShowMore = styled.button`
  width: 100%;
  font-family: var(--oc-font-family);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: var(--oc-primary-blue);
  line-height: 19px;
  text-align: center;
  text-decoration: none;
  position: relative;
  padding: 15px 0 15px;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
